'use strict';

exports.__esModule = true;
exports.styleable = exports.minimal = undefined;

var _minimal2 = require('./minimal');

var _minimal3 = _interopRequireDefault(_minimal2);

var _styleable2 = require('./styleable');

var _styleable3 = _interopRequireDefault(_styleable2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.minimal = _minimal3['default'];
exports.styleable = _styleable3['default'];


//////////////////
// WEBPACK FOOTER
// ../~/universal-logger-browser/lib/index.js
// module id = ../node_modules/universal-logger-browser/lib/index.js
// module chunks = 0